import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 pt-0 py-md-5"
}
const _hoisted_2 = { class: "d-none d-md-block justify-content-between" }
const _hoisted_3 = { class: "title-3 text-grey-900 pt-2 pb-4" }
const _hoisted_4 = {
  class: "d-md-none w-100 border-top border-1 py-3 border-top py-3",
  "data-toggle": "collapse",
  type: "button",
  "data-target": "#tf-info-domain-inner",
  "aria-expanded": "false",
  "aria-controls": "tf-info-domain-inner"
}
const _hoisted_5 = { class: "d-flex justify-content-between border-top border-gray py-2" }
const _hoisted_6 = { class: "title-3 text-grey-900 pt-2" }
const _hoisted_7 = {
  key: 0,
  "data-mobile-collapsed": "",
  "data-desktop-expanded": "",
  id: "tf-info-domain-inner",
  class: "collapse row"
}
const _hoisted_8 = {
  key: 0,
  class: "col-12 col-lg-5"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "link-large-underline link-default read-more py-3 cursor-pointer" }
const _hoisted_11 = {
  style: {"color":"var(--primary-blue)"},
  width: "10",
  height: "10"
}
const _hoisted_12 = { class: "link-large-underline link-default read-less cursor-pointer" }
const _hoisted_13 = { class: "pr-1" }
const _hoisted_14 = {
  style: {"color":"var(--primary-blue)"},
  width: "10",
  height: "16",
  viewBox: "0 0 16 16",
  class: "bi bi-chevron-up",
  fill: "none"
}
const _hoisted_15 = { class: "col-12 col-lg-7" }

import { ref, onMounted } from "vue";
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js";
import SkiAreaStats from "./SkiAreaStats.vue";
import SlopesInformation from "./SlopesInformation.vue";

interface DomainSectionProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  descriptionText: string;
  season: string;
  content: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DomainInfo',
  props: {
    data: {},
    stationData: {},
    descriptionText: {},
    season: {},
    content: {}
  },
  setup(__props: any) {

const props = __props;
const domainDescriptionWrap = ref<HTMLElement | null>(null);

const initializeTextShowMoreLess = () => {
  if (domainDescriptionWrap.value) {
    const textShowMoreLess = new TextShowMoreLess(domainDescriptionWrap.value, 15);
    textShowMoreLess.init();
  }
};

onMounted(() => {
  initializeTextShowMoreLess();
});

return (_ctx: any,_cache: any) => {
  return (_ctx.season === 'H' && (_ctx.descriptionText && _ctx.descriptionText?.length > 2))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.content.station_SkiArea) + " " + _toDisplayString(_ctx.stationData.nameDomain), 1)
        ]),
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.content.station_SkiArea) + " " + _toDisplayString(_ctx.stationData.nameDomain), 1),
            _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex d-sm-none align-items-center text-light-blue\"><svg color=\"black\" width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-up\" fill=\"none\"><use href=\"#___icon___chevron-up-bold\"></use></svg><svg color=\"black\" width=\"13\" height=\"13\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"none\"><use href=\"#___icon___chevron-down-bold\"></use></svg></div>", 1))
          ])
        ]),
        (_ctx.season === 'H')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.descriptionText?.length > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", {
                      id: "domainDescription",
                      ref_key: "domainDescriptionWrap",
                      ref: domainDescriptionWrap,
                      class: "bodytext-grey-900 pt-4 pb-3"
                    }, [
                      _createElementVNode("div", {
                        class: "body text-grey-900 show-more-less-text mb-2",
                        innerHTML: _ctx.descriptionText
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.content.station_seeMore), 1),
                        _createElementVNode("span", null, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[1] || (_cache[1] = [
                            _createElementVNode("use", { href: "#___icon___chevron-right-bold" }, null, -1)
                          ])))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.content.station_seeLess), 1),
                          (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[2] || (_cache[2] = [
                            _createElementVNode("use", { href: "#___icon___chevron-up-bold" }, null, -1)
                          ])))
                        ])
                      ])
                    ], 512)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(SkiAreaStats, {
                  pisteLength: _ctx.stationData.pisteLength,
                  nbSlopes: _ctx.stationData.nbSlopes,
                  nbSkiLifts: _ctx.stationData.nbDomainSkiLifts,
                  data: _ctx.data,
                  stationData: _ctx.stationData,
                  content: _ctx.content,
                  isConnectedDomain: false
                }, null, 8, ["pisteLength", "nbSlopes", "nbSkiLifts", "data", "stationData", "content"]),
                (_ctx.stationData.nbSlopesGreen)
                  ? (_openBlock(), _createBlock(SlopesInformation, {
                      key: 0,
                      nbSlopesGreen: _ctx.stationData.nbSlopesGreen,
                      nbSlopesBlue: _ctx.stationData.nbSlopesBlue,
                      nbSlopesRed: _ctx.stationData.nbSlopesRed,
                      nbSlopesBlack: _ctx.stationData.nbSlopesBlack,
                      domainName: _ctx.stationData.nameDomain,
                      content: _ctx.content
                    }, null, 8, ["nbSlopesGreen", "nbSlopesBlue", "nbSlopesRed", "nbSlopesBlack", "domainName", "content"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})